import {SET_SIDEBAR_SOLUTION } from '../actions/actionTypes'

const initState = {
    solution : {},
    allowedConnectors : [],
    uniqueIndexes : []
}

const sidebarReducer = (state = initState, action) => {
    // , JSON.stringify(action)
    // console.log(action.info)
    switch(action.type){
        case SET_SIDEBAR_SOLUTION : return {
            ...state,
            solution : action.solution,
            allowedConnectors : action.allowedConnectors,
            uniqueIndexes : action.uniqueIndexes
        }
        default : return state
    }
};

export default sidebarReducer;